import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {
  validateAttachmentsSize,
  validateFieldsRequiredInForm,
  validateFieldsRequiredInGeneralInformation,
} from './utils';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import ConfirmBeforePublishModal from './modal/confirmBeforePublish';

class TemplateFormButtons extends Component {
  constructor(props) {
    super(props);
    this.onNewForm = this.onNewForm.bind(this);
    this.onAddFiles = this.onAddFiles.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  isInvalidForm() {
    const {actionType, generalInfo, answers, attachments} = this.props;
    return (
      validateFieldsRequiredInGeneralInformation(actionType, generalInfo) ||
      validateFieldsRequiredInForm(actionType, answers) ||
      validateAttachmentsSize(attachments)
    );
  }

  displayErrorMessage(message) {
    this.props.addMessageBoxError(message);
  }

  onCloneFullForm(type) {
    const {formId, id} = this.props;
    this.props.navigateTo(`/formulario/${type}/${formId}/clonar-todo/${id}`);
  }

  onCloneForm(type) {
    const {formId, id} = this.props;
    this.props.navigateTo(`/formulario/${type}/${formId}/clonar/${id}`);
  }

  onNewForm() {
    this.props.navigateTo(paths.FormsList);
  }

  onAddFiles() {
    const {formOrResponseId} = this.props;
    this.props.navigateTo(`/formulario/${formOrResponseId}/editar`);
  }

  onSaveClick(status, autosave) {
    const errorMessage = this.isInvalidForm();
    if (errorMessage) {
      this.displayErrorMessage(errorMessage);
      return;
    }
    this.props.onSaveForm(status, autosave);
  }

  onDeleteClick() {
    const {id} = this.props;
    this.props.deleteFtr(id);
  }

  onUpdateClick(status, autosave) {
    const errorMessage = this.isInvalidForm();
    if (errorMessage) {
      this.displayErrorMessage(errorMessage);
      return;
    }

    const noUpdateForm =
      (status === 'entered' || status === 'published') && errorMessage;
    if (!noUpdateForm) {
      this.props.onUpdateForm(status, autosave);
    }
  }

  renderConvertToFTR() {
    const {type, status, loading} = this.props;
    if (type === 'RSR' && status === 'published') {
      return (
        <Button
          primary
          type='submit'
          className='toyota-primary'
          disabled={loading}
          onClick={() => this.onCloneFullForm('FTR')}
        >
          Convertir a FTR
        </Button>
      );
    }
    return null;
  }

  renderViewButtons() {
    const {actionType, loading, saving, deleting, type, status} = this.props;

    if (actionType === 'ver') {
      return (
        <div>
          <Button
            primary
            type='submit'
            className='toyota-primary'
            disabled={loading}
            onClick={() => this.onCloneForm(type)}
          >
            Clonar
          </Button>
          {this.renderConvertToFTR()}
          <Button
            primary
            type='submit'
            className='toyota-primary'
            disabled={loading}
            onClick={this.onNewForm}
          >
            Nuevo
          </Button>
          {type === 'RSR' && status === 'published' && (
            <Button
              color='black'
              type='submit'
              className='toyota-primary'
              disabled={loading || saving || deleting}
              onClick={this.onAddFiles}
            >
              Agregar adjuntos
            </Button>
          )}
        </div>
      );
    }
  }

  renderSaveButton() {
    const {actionType, loading, saving} = this.props;

    if (
      actionType === 'clonar' ||
      actionType === 'clonar-todo' ||
      actionType === 'nuevo'
    ) {
      return (
        <Button
          primary
          type='submit'
          className='toyota-primary'
          disabled={loading || saving}
          onClick={() => this.onSaveClick('entered', false)}
        >
          Guardar
        </Button>
      );
    }
  }

  renderEditButtons() {
    const {actionType, loading, saving, deleting, type, section, status} =
      this.props;
    if (actionType === 'editar') {
      const statusForm = status === 'published' ? 'published' : 'entered';
      return (
        <div>
          {status !== 'published' && (
            <Button
              primary
              type='submit'
              className='toyota-primary'
              disabled={loading || saving || deleting}
              onClick={this.onDeleteClick}
            >
              Eliminar
            </Button>
          )}
          <Button
            primary
            type='submit'
            className='toyota-primary'
            disabled={loading || saving || deleting}
            onClick={() => this.onUpdateClick(statusForm, false)}
          >
            Guardar
          </Button>
          {status !== 'published' && (
            <ConfirmBeforePublishModal
              loading={loading}
              saving={saving}
              formType={type}
              section={section}
              confirmClick={() => this.onUpdateClick('published', false)}
            />
          )}
        </div>
      );
    }
  }

  render() {
    return (
      <div className='title-bar-actions'>
        {this.renderViewButtons()}
        {this.renderSaveButton()}
        {this.renderEditButtons()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'formOrResponseId': state.templateFTR.id,
    'loading': state.templateFTR.loading,
    'saving': state.templateFTR.saving,
    'saved': state.templateFTR.saved,
    'autosave': state.templateFTR.autosave,
    'formId': state.templateFTR.formId,
    'section': state.templateFTR.section,
    'type': state.templateFTR.type,
    'status': state.templateFTR.status,
    'generalInfo': state.templateFTR.generalInfo,
    'answers': state.templateFTR.answers,
    'attachments': state.templateFTR.attachments,
    'deleting': state.templateFTR.deleting,
  };
};

const {navigateTo, addMessageBoxError, deleteFtr} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  addMessageBoxError,
  deleteFtr,
})(TemplateFormButtons);
